import styled from 'styled-components';
import { media } from '../../styles/theme';

// Header no topo, sidebar à esquerda (só desktop) e conteúdo com scroll próprio
export const Container = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.layout.larguraSidebar} minmax(0, 1fr);
  grid-template-rows: ${({ theme }) => theme.layout.alturaHeader} minmax(0, 1fr);
  grid-template-areas:
    'header header'
    'sidebar conteudo';
  height: 100dvh;

  ${media.mobile} {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      'header'
      'conteudo';
  }

  @media print {
    display: block;
    height: auto;
  }
`;

export const Conteudo = styled.main`
  grid-area: conteudo;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ theme }) => theme.espaco.xl};

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.lg};
  }

  @media print {
    overflow: visible;
    padding: 0;
  }
`;
